import { render } from "./UserOperationLogs.vue?vue&type=template&id=15ffa79c&scoped=true"
import script from "./UserOperationLogs.vue?vue&type=script&lang=js"
export * from "./UserOperationLogs.vue?vue&type=script&lang=js"

import "./UserOperationLogs.vue?vue&type=style&index=0&id=15ffa79c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15ffa79c"]])

export default __exports__